namespace RioERP.Carts {
    export interface CartForm {
        FranchiseeId: Serenity.LookupEditor;
        CustomerName: Serenity.StringEditor;
        CustomerEmail1: Serenity.EmailEditor;
        CustomerMobile1: Serenity.StringEditor;
        ShippingAddress1: Serenity.TextAreaEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingStateId: Serenity.LookupEditor;
        ShippingPincode: Serenity.IntegerEditor;
        GrossAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        CartProducts: CartProductsEditor;
    }

    export class CartForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.Cart';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CartForm.init)  {
                CartForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.EmailEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.DecimalEditor;
                var w6 = CartProductsEditor;

                Q.initFormType(CartForm, [
                    'FranchiseeId', w0,
                    'CustomerName', w1,
                    'CustomerEmail1', w2,
                    'CustomerMobile1', w1,
                    'ShippingAddress1', w3,
                    'ShippingCity', w1,
                    'ShippingStateId', w0,
                    'ShippingPincode', w4,
                    'GrossAmount', w5,
                    'NetAmount', w5,
                    'TaxableAmount', w5,
                    'TaxAmount', w5,
                    'FranchiseeDiscountAmount', w5,
                    'CartProducts', w6
                ]);
            }
        }
    }
}
